import useStore from '../store/useStore'

export default () => useStore(s => s.firestoreUser)
